import { baseUrl, httpClient } from 'src/pages/admin/providers/AppDataProvider';

import type { ReplaceWhitelistPayload, WhitelistResponse } from './types';
import { normalizeWhitelist } from './utils';

const resourceBase = 'world-cup/user-vouchers/whitelist';

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const { json } = await httpClient(`${baseUrl}/${resourceBase}${path}`, options as any);
  return json as T;
}

export const whitelistApi = {
  async list(signal?: AbortSignal): Promise<WhitelistResponse> {
    const data = await request<unknown>('', {
      method: 'GET',
      signal,
    } as any);

    return normalizeWhitelist(data);
  },

  async replace(payload: ReplaceWhitelistPayload): Promise<WhitelistResponse> {
    const data = await request<unknown>('', {
      method: 'PUT',
      body: JSON.stringify(payload),
    });

    return normalizeWhitelist(data);
  },
};
